import { configureStore } from '@reduxjs/toolkit'
import themeReducer from './features/theme/themeSlice';
import trackReducer from './features/track/trackSlice';

export const store = configureStore({
    reducer: {
        theme: themeReducer,
        track: trackReducer
    }
});